import { Badge, ListItemIcon } from "@mui/material";

interface Props {
  icon: React.ReactNode;
  count?: number;
  isCollapsed: boolean;
}

export function NavigationItemIcon({ icon, count, isCollapsed }: Props) {
  return (
    <ListItemIcon
      sx={{
        minWidth: 0,
        mr: isCollapsed ? 0 : 1.5,
        justifyContent: "center",
        color: "inherit",
      }}
    >
      {isCollapsed && count ? (
        <Badge
          variant="dot"
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          sx={{
            "& .MuiBadge-badge": {
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "fsw.oragen-wcag",
            },
          }}
        >
          {icon}
        </Badge>
      ) : (
        icon
      )}
    </ListItemIcon>
  );
}
